import { defineStore } from 'pinia'
import StoreService from "@/services/store.service.ts";
import WarehouseService from "@/services/warehouse.service.js";
export const useStore = defineStore('store', {
    state: () => {
        return {
            stores: [],
            storeByRoles: [],
            storesLimit: [],
            usingStore: null,
            store: null,
            paginate: {},
            lastPage: 1,
            lastFetched: null,
            CACHE_DURATION: 5 * 60 * 1000
        }
    },
    persist: true,
    actions: {
        async getListStores(url, params) {
            const now = Date.now()
            const isCacheExpired =
                !this.lastFetched || now - this.lastFetched > this.CACHE_DURATION

            if (this.stores.length > 0 && !isCacheExpired) {
                return this.stores
            }
            try {
                const res = await StoreService.getListStores(url, params)
                if(!params.page && !params.take) {
                    this.stores = res.data
                }
                if(params.page || params.take) {
                    this.storesLimit = res.data.data
                    this.paginate = res.data.meta
                    this.lastPage = res.data.meta.page
                }
            } catch (e) {
                return null
            }
        },
        async getStoreDetail(url, params) {
            try {
                const res = await StoreService.getStoreDetail(url, params)
                this.store = res.data
            } catch (e) {
                return null
            }
        },
        async createOrUpdateStore(url, params) {
            try {
                const res = await StoreService.createOrUpdateStore(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },
        async deleteStore(url, params) {
            try {
                const res = await StoreService.deleteStore(url, params)
                return res.data;
            } catch (e) {
                return null
            }
        },
        async getListStoreByRole(url, params) {
            try {
                const res = await StoreService.getListStoreByRole(url, params)
                this.storeByRoles = res.data
            } catch (e) {
                return null
            }
        },
    }
})
